import _taggedTemplateLiteral from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: block;\n    margin-bottom: 20px;\n    max-width: 100%;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    margin-top: 40px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Typography } from '../Typography';
var StyledNotFoundPlaceholder = styled.div(_templateObject());
var Content = styled.div(_templateObject2());
var Image = styled.img(_templateObject3());
export var NotFoundPlaceholder = forwardRef(function (_a, ref) {
  var children = _a.children,
      imgSrc = _a.imgSrc,
      _a$strings = _a.strings,
      strings = _a$strings === void 0 ? {} : _a$strings,
      props = __rest(_a, ["children", "imgSrc", "strings"]);

  return React.createElement(StyledNotFoundPlaceholder, Object.assign({}, props, {
    ref: ref
  }), imgSrc && React.createElement(Image, {
    src: imgSrc,
    alt: strings.altText || 'Not found placeholder'
  }), strings.title && React.createElement(Typography, {
    variant: 'h1',
    gutterBottom: 8
  }, strings.title), strings.description && React.createElement(Typography, {
    variant: 'h5'
  }, strings.description), children && React.createElement(Content, null, children));
});
NotFoundPlaceholder.displayName = 'NotFoundPlaceholder';